import EmblaCarousel from 'embla-carousel';
import Autoscroll from 'embla-carousel-auto-scroll';

/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener("DOMContentLoaded", function (event) {

    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function (e) {

        const emblaNode = document.querySelector('.embla');
        const options = { loop: true, dragFree: true, watchFocus: false };
        const plugins = [Autoscroll({ startDelay: 0, stopOnMouseEnter: true, speed: 0.75 })];

        const emblaApi = EmblaCarousel(emblaNode, options, plugins);
        emblaNode.addEventListener("mouseleave", () => {emblaApi.plugins().autoScroll.play()});
        emblaNode.addEventListener("touchend", () => {emblaApi.plugins().autoScroll.play()});

    }, false);
});


